const SiteLoading = () => {
  return (
    <div className="kf-a-site-loading">
      <div className="kf-a-site-loading__triangle">
        <div className="kf-a-site-loading__blank" />
        <div className="kf-a-site-loading__triangle-topleft" />
        <div className="kf-a-site-loading__blank" />
        <div className="kf-a-site-loading__triangle-topright" />
        <div className="kf-a-site-loading__blank" />
        <div className="kf-a-site-loading__triangle-bottomleft" />
        <div className="kf-a-site-loading__blank" />
        <div className="kf-a-site-loading__triangle-bottomright" />
        <div className="kf-a-site-loading__blank" />
      </div>
    </div>
  );
};

export default SiteLoading;
